import React from 'react'
import { string } from 'prop-types'
import { Card, HyperButton, Subheading } from '@offerzen/pinata'

import styles from './styles'

const TermsLinkCard = ({ title, termsLink, buttonLabel = 'View terms' }) => (
  <Card className={styles.card}>
    <Subheading className={styles.subheading}>{title}</Subheading>
    <HyperButton
      label={buttonLabel}
      href={termsLink}
      external
      variant="outlined"
    />
  </Card>
)

TermsLinkCard.propTypes = {
  title: string.isRequired,
  termsLink: string.isRequired,
  buttonLabel: string,
}

export default TermsLinkCard
